import { gumballAbi } from "../assets/abis/gumballAbi";
import { animaAbi } from "../assets/abis/animaAbi";
import { erc1155abi } from "../assets/abis/erc1155abi";
import { erc721abi } from "../assets/abis/erc721abi";

function getContractReadsGumball(addresses, handleOnSuccess) {
    const ContractReads = {
        contracts: [
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "animaCost",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "maticCost",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getPaused",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getMaticEnabled",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getBurnableEnabled",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getBurnableLimited",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getBurnableContract",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getBurnableIds",
                args: [],
            },
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "getAvailableTokenCount",
                args: [],
            },
        ],
        onerror(error) {
            console.error("getContractReadsGumball Error!", error);
        },
        onSuccess(data) {
            //console.log("On success getContractReadsGumball");
            handleOnSuccess(data);
        },
    };

    return ContractReads;
}

function getContractReadsAnima(addresses, wallet, handleOnSuccess) {
    /* console.log(
        `get anima reads for wallet: ${wallet} from anima: ${addresses.anima}`
    ); */
    const ContractReads = {
        contracts: [
            {
                address: addresses.anima,
                abi: animaAbi,
                functionName: "balanceOf",
                args: [wallet],
            },
            {
                address: addresses.anima,
                abi: animaAbi,
                functionName: "allowance",
                args: [wallet, addresses.gumball],
            },
        ],
        onerror(error) {
            console.error("getContractReadsResToken Error!", error);
        },
        onSuccess(data) {
            handleOnSuccess(data);
        },
    };

    return ContractReads;
}

const getMetadata721config = (contract, id) => {
    const readMetadataConfig = {
        contracts: [
            {
                address: contract,
                abi: erc721abi,
                functionName: "name",
            },
            {
                address: contract,
                abi: erc721abi,
                functionName: "symbol",
            },
            {
                address: contract,
                abi: erc721abi,
                functionName: "tokenURI",
                args: [id],
            },
        ],
    };

    return readMetadataConfig;
};

const getMetadata1155config = (contract, id) => {
    const readMetadataConfig = {
        contracts: [
            {
                address: contract,
                abi: erc1155abi,
                functionName: "name",
            },
            {
                address: contract,
                abi: erc1155abi,
                functionName: "symbol",
            },
            {
                address: contract,
                abi: erc1155abi,
                functionName: "uri",
                args: [id],
            },
        ],
    };

    return readMetadataConfig;
};

const contractReadAvalableInfos = (
    addresses,
    infoStartIndex,
    infoGroupCount
) => {
    return {
        contracts: [
            {
                address: addresses.gumball,
                abi: gumballAbi,
                functionName: "listAvalableTokenInfos",
                args: [infoStartIndex, infoGroupCount],
            },
        ],
    };
};

const getContractReadsBurnableName = (
    burnableAddress,
    burnableEnabled,
    handleOnSuccess
) => {
    const contracts = {
        contracts: [
            {
                address: burnableAddress,
                abi: erc1155abi,
                functionName: "name",
                args: [],
            },
            {
                address: burnableAddress,
                abi: erc1155abi,
                functionName: "symbol",
                args: [],
            },
        ],
        enabled: burnableEnabled,
        onerror(error) {
            console.error("getContractReadsBurnableName Error!", error);
        },
        onSuccess(data) {
            //console.log("On success getContractReadsBurnableName");
            handleOnSuccess(data);
        },
    };

    //console.log(`getContractReadsBurnableName: ${JSON.stringify(contracts)}`);
    return contracts;
};

const getContractReadsBurnableBalances = (
    burnableAddress,
    wallet,
    ids,
    gumballAddress,
    burnableEnabled,
    handleOnSuccess
) => {
    const walletaddresses = Array(ids.length).fill(wallet);

    const contract = {
        contracts: [
            {
                address: burnableAddress,
                abi: erc1155abi,
                functionName: "balanceOfBatch",
                args: [walletaddresses, ids],
            },
            {
                address: burnableAddress,
                abi: erc1155abi,
                functionName: "isApprovedForAll",
                args: [wallet, gumballAddress],
            },
        ],
        enabled: burnableEnabled,
        onerror(error) {
            console.error("getContractReadsBurnableBalances Error!", error);
        },
        onSuccess(data) {
            //console.log("On success getContractReadsBurnableBalances");
            handleOnSuccess(data);
        },
    };
    /* console.log(
        `getContractReadsBurnableBalances: ${JSON.stringify(contract)}`
    ); */

    return contract;
};

export {
    getContractReadsGumball,
    getContractReadsAnima,
    getMetadata721config,
    getMetadata1155config,
    contractReadAvalableInfos,
    getContractReadsBurnableName,
    getContractReadsBurnableBalances,
};
